import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7629 6.77239C19.3723 6.38186 18.7392 6.38186 18.3487 6.77239L9.58548 15.5356L6.70711 12.6572C6.31658 12.2667 5.68342 12.2667 5.29289 12.6572C4.90237 13.0477 4.90237 13.6809 5.29289 14.0714L8.82843 17.6069C9.03703 17.8155 9.31486 17.9127 9.58797 17.8985C9.85954 17.9113 10.1354 17.8141 10.3428 17.6067L19.7629 8.1866C20.1534 7.79607 20.1534 7.16291 19.7629 6.77239Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);

var TickSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { TickSolid as default };
